var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoffee = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.6 25.2c1.4-.7 2.4-1.8 3.1-3.1 2.3-.3 3.7-2.1 3.7-4.2 0-1.7-.6-3.8-2.3-4.4H10.9c0 3.1-.2 9.2 4.5 11.7M33.5 25.2c0 2.1-8.3 2.7-13.1 2.7-3.9 0-12.9-.8-12.9-2.7zM29.8 15.8l-.9 3.9"
}))));
export default SvgCoffee;